import { Department, Prisma } from '@prisma/client';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { DepartmentDto } from '@app/integ-apigee-interfaces';
import { Axios } from '@app/web-components';

const DEPARTMENT_ALL_QUERY_KEY = 'DEPARTMENT_ALL_QUERY_KEY';
export const departmentKeys = {
  all: [DEPARTMENT_ALL_QUERY_KEY] as const,
  lists: () => [...departmentKeys.all, 'list'] as const,
  list: (filters: object) => [...departmentKeys.lists(), filters] as const,
  item: (code: string) => [...departmentKeys.all, 'item', code] as const,
};

/* Fetch all departments from Worker source. Used by DepartmentCascader control to construct the tree in dropdown */
export const useFindAllDepartments = () => {
  const axios = Axios.useAxiosApi();

  return useQuery<DepartmentDto[]>({
    queryKey: departmentKeys.lists(),
    queryFn: async () => {
      const { data } = await axios.get(`/worker-departments`);
      return data;
    },
  });
};

export const useFindDepartmentByCode = (code: string | null | undefined, options?: UseQueryOptions<DepartmentDto>) => {
  const axios = Axios.useAxiosApi();

  return useQuery<DepartmentDto>({
    queryKey: departmentKeys.item(code ?? ''),
    queryFn: async () => {
      const { data } = await axios.get(`/worker-departments/${code}`);
      return data;
    },
    ...options,
    enabled: !!code && (options?.enabled ?? true),
  });
};

/* Find query to get departments from local DB */
export const useDepartmentQuery = (params: Prisma.DepartmentFindManyArgs) => {
  const axios = Axios.useAxiosApi();

  return useQuery<Department[]>({
    queryKey: departmentKeys.list([]),
    queryFn: async () => {
      const { data } = await axios.post('/departments/find', params);
      return data;
    },
  });
};
